// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2136":"rrule","3724":"VoltoFormBlockEdit","4328":"Widgets","4348":"taxonomy-edit-tree","5772":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"2136":"82f0a0ec","3724":"5e815994","4328":"ac119948","4348":"5598ea9f","5772":"ac119948"}[chunkId] + ".chunk.css";
};